<template>
	<section class="rules-popup">
		<div class="rules-popup__content">
			<ScrollFade>
				<template #scrollContent>
					<div class="rules-popup__items">
						<div class="rule__title">
							{{ translate("rules.general_rules") }}
						</div>
						<ul class="rules-popup__list">
							<li class="rule__text" v-for="i in 7" :key="i">
								{{ translate(`rules.general_${i}`) }}
							</li>
						</ul>
						<div class="rule__title">
							{{ translate("rules.forbidden") }}
						</div>
						<ul class="rules-popup__list">
							<li class="rule__text" v-for="i in 10" :key="i">
								{{ translate(`rules.forbidden_${i}`) }}
							</li>
						</ul>
					</div>
				</template>
			</ScrollFade>
		</div>
	</section>
</template>

<script lang="ts" setup>
import ScrollFade from "@/components/ScrollFade.vue";
import { translate } from "@/utils/translate";
</script>

<style lang="scss" scoped>
.rules-popup {
	@include flex-col-center;
	gap: 0.85rem;

	&__content {
		padding-bottom: 1rem;
		width: 100%;
	}
	&__items {
		max-height: 18rem;
	}
	.rule {
		&__title {
			color: #f4d278;
			font-weight: bold;
			font-size: 1.25rem;
			text-align: center;
			@include background(
				url($path-images + "popups/news-title-bg.avif"),
				100% 100%,
				center,
				no-repeat
			);
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 auto;
			margin-top: 0.438rem;
			margin-bottom: 0.438rem;
			padding-bottom: 0.25rem;
			width: 98%;
			height: 1.875rem;
			line-height: 1.2rem;
		}

		&__text {
			padding: 0 1rem;
			color: #fff3dd;
			font-size: 0.906rem;
		}
	}

	&__list {
		margin-bottom: 0.438rem;
		margin-left: 2rem;
	}
}
</style>
